import { FC } from 'react'
import { Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import { Logo } from '@components/atoms/assets/Logo'

import { appConfig } from '@/services/config'
import { OnboardingData } from '@/lib/hooks/useOnboarding'

type OnboardingSwiperProps = {
  slidesData: OnboardingData['items']
}

export const OnboardingSwiper: FC<OnboardingSwiperProps> = ({ slidesData }) => {
  if (!slidesData) return null

  return (
    <div className="w-full h-[100dvh]">
      <Swiper
        modules={[Pagination]}
        slidesPerView={1}
        pagination={{ clickable: true }}
        className="onboarding"
        loop
      >
        {slidesData?.map((d) => (
          <SwiperSlide key={d.title}>
            <div className="w-full h-[100dvh] flex flex-col bg-[#141820]">
              <img
                src={`${appConfig.origin}/${d.image}`}
                className="w-full h-full object-cover"
              />
              <div
                className={`absolute z-10 w-full -bottom-6 sm:bottom-[6%] flex flex-col items-center justify-end pb-44`}
              >
                <Logo className="fill-primary w-[20%] max-w-[4rem] mb-4" />
                <div className="flex flex-col mx-8">
                  <p className="text-[6vw] sm:text-2xl mb-[2vw] font-semibold pb-2">
                    {d.title}
                  </p>
                  <p className="text-[4vw] sm:text-sm">{d.subtitle}</p>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}
